module.exports = {"411524001":"赤城街道","411524002":"鲇鱼山街道","411524101":"上石桥镇","411524102":"鄢岗镇","411524103":"双椿铺镇","411524104":"汪桥镇","411524105":"余集镇","411524106":"达权店镇","411524107":"丰集镇","411524108":"汪岗镇","411524109":"观庙镇","411524110":"金刚台镇","411524203":"河风桥乡","411524204":"李集乡","411524207":"苏仙石乡","411524209":"伏山乡","411524212":"吴河乡","411524213":"冯店乡","411524215":"长竹园乡","411524400":"汤泉池管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411524.json
// module id = 1669
// module chunks = 0